import React from 'react';

import styles from './styles/layout-frame.module.css';

export default function LayoutFrame({ leftSideBar, middleSideBar, children, rightSideBar }) {
    return (
        <div className={styles.frame}>
            {leftSideBar && 
                <aside className={styles.left}>
                    {leftSideBar}
                </aside>
            }

            {middleSideBar && 
                <section className={styles.middle}>
                    {middleSideBar}
                </section>
            }

            <main className={styles.content}>
                {children}
            </main>

            {rightSideBar && 
                <aside className={styles.right}>
                    {rightSideBar}
                </aside>
            }
        </div>
    );
}
